const animations = document.querySelectorAll('.animation')

if (animations.length) {
  const inView = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animation--active')
        // observer.unobserve(entry.target)
      } else {
        entry.target.classList.remove('animation--active')
      }
    })
  })

  animations.forEach((animation) => {
    inView.observe(animation)
  })
}
